import { Modal } from "@4uhub/lib4uhub";
import TopicIcon from "@mui/icons-material/Topic";
import { Box, Tooltip, Typography } from "@mui/material";
import { memo, useState } from "react";
import { useTranslation } from "react-i18next";

import IconButton from "../../UI/IconButton";
import { IExamsResultLabPdfsProps } from "./models";
import { ExamsResultLabPdfsModal } from "./ExamsResultLabPdfsModal/ExamsResultLabPdfsModal";
import { ViewExamsResultLabPdfTable } from "./ViewExamsResultLabPdfTable/ViewExamsResultLabPdfTable";
import ExamsDownload from "../ExamsDownload/ExamsDownload";

const translationPath = "components.examsDownload.";

export const ExamsResultLabPdf = memo(
  ({ exam, cdnUrl, individualId }: IExamsResultLabPdfsProps) => {
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);

    const openModalHandler = () => setOpen(true);
    const closeModalHandler = () => setOpen(false);

    if (exam.pdfSerialFileExists === 0) {
      if (exam.medicalCertificateContent) {
        return (
          <ExamsDownload
            id={exam.id.toString()}
            examType={exam.type}
            date={exam.medicalCertificateDate}
            individualId={individualId}
          />
        );
      }

      return <Typography component="span">-</Typography>;
    }

    return (
      <>
        <Modal
          open={open}
          onClose={closeModalHandler}
          title={`${t(translationPath + "report")}`}
          maxDialogWidth={"xs"}
        >
          <ExamsResultLabPdfsModal identifier={exam.id} cdnUrl={cdnUrl} />
        </Modal>

        <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
          <Tooltip
            title={t(translationPath + "open_report")}
            placement="bottom"
          >
            <Box>
              <IconButton onClick={openModalHandler}>
                <TopicIcon fontSize="small" />
              </IconButton>
            </Box>
          </Tooltip>

          <ViewExamsResultLabPdfTable identifier={exam.id} cdnUrl={cdnUrl} />
        </Box>
      </>
    );
  },
);
